import {
    utilBaseQuery,
    transformErrorResponse,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const utilapi = createApi({
    baseQuery: utilBaseQuery,
    reducerPath: 'utilapi',
    endpoints: (builder) => ({

        getJobSkillDropdown: builder.query({
            query: () => ({
                url: `/util/student/dropdown?pageName=JOB_SKILL`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getStudentDropdown: builder.query({
            query: () => ({
                url: `/util/student/dropdown`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    }),
});

export const {
    useLazyGetJobSkillDropdownQuery,
    useLazyGetStudentDropdownQuery
} = utilapi;

export default utilapi;
